"use client";

import { useEffect } from "react";
import { ORDER_TYPE } from "@/lib/orderType";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { closeCartDrawer } from "@/store/slices/uiSlice";
import GroceryCartDrawer from "./GroceryCartDrawer";
import TakeoutCartDrawer from "./TakeoutCartDrawer";
import "./cart.css";

export default function CartDrawerHost() {
  const dispatch = useAppDispatch();
  const drawer = useAppSelector((state) => state.ui.cartDrawer);

  useEffect(() => {
    if (!drawer) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    function handleEscape(event) {
      if (event.key === "Escape") dispatch(closeCartDrawer());
    }

    window.addEventListener("keydown", handleEscape);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleEscape);
    };
  }, [drawer, dispatch]);

  if (!drawer) return null;

  const onClose = () => dispatch(closeCartDrawer());

  return (
    <div
      className="asian-bucket-cart-drawer-overlay-main-wrapper"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      {drawer === ORDER_TYPE.TAKEOUT ? (
        <TakeoutCartDrawer onClose={onClose} />
      ) : (
        <GroceryCartDrawer onClose={onClose} />
      )}
    </div>
  );
}
